module.exports = __webpack_public_path__ + "static/media/57.0176ab16.jpg";